import { z } from 'zod'
import { oc } from '@orpc/contract'

export const ORDER_FAX_STATUSES = [
  'none',
  'queued',
  'sent',
  'delivered',
  'failed',
  'unknown',
] as const

export const orderFaxStatusInputSchema = z.object({ requestGroupId: z.string().min(1).max(64) })

export const orderFaxStatus = oc
  .route({ method: 'GET', path: '/v2/orders/{requestGroupId}/fax-status' })
  .input(orderFaxStatusInputSchema)
  .output(
    z.object({
      status: z.enum(ORDER_FAX_STATUSES),
      recipient: z.string().optional(),
      sentAt: z.string().optional(),
      pageCount: z.number().int().optional(),
    }),
  )
